import { render, staticRenderFns } from "./EpayPayment.vue?vue&type=template&id=54aaf863&scoped=true"
import script from "./EpayPayment.vue?vue&type=script&lang=js"
export * from "./EpayPayment.vue?vue&type=script&lang=js"
import style0 from "./EpayPayment.vue?vue&type=style&index=0&id=54aaf863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aaf863",
  null
  
)

export default component.exports